import React from 'react';
import {
  TabbedShowLayout,
  TextField,
  RichTextField,
  Datagrid,
  BooleanField,
  ArrayField,
  Show,
  FunctionField,
  useRecordContext,
} from 'react-admin';
import ImgField from '../../../components/ImgField/ImgField';
import exerciseType from '../../../constants/exerciseType';

const ExerciseType = () => {
  const record = useRecordContext();
  if (!record) return null;
  return <span>{exerciseType[record.type]}</span>;
};

const DemoVideoField = () => {
  const record = useRecordContext();
  if (!record?.video?.muxPlaybackId) return null;
  const url = `https://stream.mux.com/${record.video.muxPlaybackId}/low.mp4`;
  return (
    <a href={url} target="_blank" rel="noreferrer">
      {record.video.originalName || 'Demo Video'}
    </a>
  );
};

const TutorialVideoField = () => {
  const record = useRecordContext();
  if (!record?.fullVideo?.muxPlaybackId) return null;
  const url = `https://stream.mux.com/${record.fullVideo.muxPlaybackId}/low.mp4`;
  return (
    <a href={url} target="_blank" rel="noreferrer">
      {record.fullVideo.originalName || 'Full Video'}
    </a>
  );
};

const ExercisesShow = (props) => {
  return (
    <Show {...props}>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label="Main information">
          <ImgField source="picture" title="Picture" addLabel width="100" height="100" />
          <TextField source="name" />
          <RichTextField source="description" />
          <FunctionField label="Video" render={() => <DemoVideoField />} />
          <FunctionField label="Full Video" render={() => <TutorialVideoField />} />
          <BooleanField source="forEachSide" label="Ask user to switch sides and repeat exercise" />
          <FunctionField label="Exercise Type" render={() => <ExerciseType />} />
          <BooleanField source="doneButton" label="Hide done button in timer" />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Cue images">
          <ArrayField source="cueImages" label={false} style={{ minWidth: '100%' }}>
            <Datagrid style={{ minWidth: '100%' }} bulkActionButtons={false}>
              <ImgField source="picture" title="Picture" addLabel width="50" height="50" />
              <RichTextField source="description" />
            </Datagrid>
          </ArrayField>
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="On screen tips">
          <RichTextField label="Tip 1" source="tips.0" />
          <RichTextField label="Tip 2" source="tips.1" />
          <RichTextField label="Tip 3" source="tips.2" />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Relation">
          <ArrayField source="relation" label={false}>
            <Datagrid bulkActionButtons={false}>
              <FunctionField
                label="Session Name (Program Name)"
                render={(record) =>
                  `${record.session?.name || '-'} (${record.session?.program?.name || '-'})`
                }
              />
            </Datagrid>
          </ArrayField>
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default ExercisesShow;
